import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromAuth from './auth.reducer';
import * as fromConfig from './config.reducer';
import * as fromShift from '../../shifts/store/reducers';
import {InjectionToken} from '@angular/core';
import * as formSettings from '../../settings/store/reducers';
import * as fromFreelancers from '../../freelancers/store/reducers';
import * as fromProfile from '../../profile/store/reducers';
import * as fromDashboard from '../../dashboard/store/reducers';

export interface AppState {
  auth: fromAuth.AuthState;
  settingsFeature: formSettings.SettingsState;
  shift: fromShift.ShiftState;
  freelancerFeature: fromFreelancers.FreelancerState;
  profileFeature: fromProfile.ProfileState;
  dashboardFeature: fromDashboard.DashboardState;
  config: fromConfig.ConfigState;
}

const reducers = {
  auth: fromAuth.reducer,
  settingsFeature: formSettings.reducer,
  shift: fromShift.reducer,
  freelancerFeature: fromFreelancers.reducer,
  profileFeature: fromProfile.reducer,
  dashboardFeature: fromDashboard.reducer,
  config: fromConfig.reducer,
};

export const reducerToken = new InjectionToken<ActionReducerMap<AppState>>('Reducer Registered');

export const reducerProvider = [{provide: reducerToken, useValue: reducers}];




// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/reducers/index.ts